import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { AwsService } from '../../providers/appsyncservice/aws.service';
import { LoginService } from '../../service/login/login.service';
import { AuthService } from '../../guard/auth.service';
import { interval, Subscription } from 'rxjs';
import { TokenRefreshService } from '../../service/tokenRefreshService';

@Component({
  selector: 'app-callback',
  template: `
    <div class="callback-container" *ngIf="!errorData">
      <h2>Processing...</h2>
      <p>Please wait while we complete your authentication.</p>
    </div>
    
    <div class="callback-container error" *ngIf="errorData">
      <h2>Access Denied</h2>
      <p>You are not authorized to access this application.</p>
    </div>
  `,
  styles: [`
    .callback-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100vh;
    }
    .callback-container.error {
      color: #d32f2f;
    }
    .callback-container.error h2 {
      color: #d32f2f;
    }
  `]
})
export class CallbackComponent implements OnInit {
  private loginResult: any;
  private user_type: number;
  errorData: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private awserviceProvider: AwsService,
    private loginService: LoginService,
    private auth: AuthService,
    private tokenRefreshService: TokenRefreshService
  ) { }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      // Handle callback parameters (code, state, etc.)
      const code = params['code'];
      const state = params['state'];
      const error = params['error'];

      if (error) {
        console.error('Authentication error:', error);
        this.router.navigate(['/']);
      } else if (code) {
        // Process the authorization code
        this.getAuthenticationToken(code);
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  private getAuthenticationToken(authorizationCode: string): void {
    const tokenEndpoint = environment.smsUrl[window.location.origin] + '/getauthenticationtoken';
    const apiBase = environment.smsUrl[window.location.origin];
    if (!apiBase) {
      console.error('No API base URL configured for origin:', window.location.origin);
      return; // Stop further processing if API base is not configured
    }
    const requestBody = {
      code: authorizationCode
    };
    const httpOptions = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    this.http.post(tokenEndpoint, requestBody, httpOptions).subscribe(
      (tokenResponse: any) => {
        this.handleTokenResponse(tokenResponse);
      },
      (error) => {
        this.auth.stopTokenRefresh();
        console.error('Token exchange failed:', error);
      }
    );
  }

  handleTokenResponse(tokenResponse: any): void {
    const okta_accesstoken = tokenResponse.access_token;
    localStorage.setItem('oktaAccessToken', tokenResponse.access_token);
    localStorage.setItem('oktaIdToken', tokenResponse.id_token);
    if (tokenResponse.expires_in) {
      localStorage.setItem('oktaRefreshToken', tokenResponse.refresh_token); // store refresh token
      this.auth.scheduleTokenRefresh(tokenResponse.refresh_token, tokenResponse.expires_in);
    }
    let user_zid = tokenResponse.user.preferred_username.toUpperCase();
    const loginUrl = environment.smsUrl[window.location.origin] + '/loginapi';
    const payload = {
      zid: user_zid
    };
    this.http.post(loginUrl, payload).subscribe(
      (response: any) => {
        this.loginResult = response;
        let username = this.loginResult.user_name;
        if (this.loginResult != null && this.loginResult.user_name !== null && this.loginResult.user_name !== undefined) {
          // Save PgRest tokens and schedule refresh
          localStorage.setItem('pg_refresh_token', this.loginResult.refresh_token);
          if (this.loginResult.user_type != 0 && this.loginResult.user_type != 4 && this.loginResult.user_type != 5 && this.loginResult.isadmin == 1) {
            this.user_type = 0;
            this.loginService.setUserType(0);
            this.auth.sendToken(username, "0", this.loginResult.token, okta_accesstoken);
            this.router.navigate(["./pages/dashboard"]);
          } else if (this.loginResult.user_type === 0) {
            this.user_type = 0;
            this.loginService.setUserType(0);
            this.auth.sendToken(username, "0", this.loginResult.token, okta_accesstoken);
            this.router.navigate(["./pages/dashboard"]);
          } else if (this.loginResult.user_type === 1 || this.loginResult.user_type === 2) {
            this.setErrorAndRedirect();
          } else if (this.loginResult.user_type === 4 && this.loginResult.isadmin === 1) {
            this.loginService.setUserType(4);
            this.user_type = 4;
            this.auth.sendToken(username, "4", this.loginResult.token, okta_accesstoken);
            this.router.navigate(["./pages/vehiclems"]);
          } else if (this.loginResult.user_type === 5 && this.loginResult.isadmin === 1) {
            this.loginService.setUserType(5);
            this.user_type = 5;
            this.auth.sendToken(username, "5", this.loginResult.token, okta_accesstoken);
            this.router.navigate(["./pages/wellness"]);
          }
        } else {
          this.setErrorAndRedirect();
        }
      },
      (error) => {
        console.error('SMS Login error:', error);
        this.auth.stopTokenRefresh();
        this.setErrorAndRedirect();
      }
    );
  }

  private setErrorAndRedirect(): void {
    this.errorData = true;
    setTimeout(() => {
      this.router.navigate(['/']); // Navigate to login component
    }, 3000);
  }
}
